import { render } from "./page5.vue?vue&type=template&id=4247bfac&scoped=true"
import script from "./page5.vue?vue&type=script&lang=js"
export * from "./page5.vue?vue&type=script&lang=js"

import "./page5.vue?vue&type=style&index=0&id=4247bfac&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-space-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4247bfac"]])

export default __exports__